"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_TRACKING_DATA = exports.LINKID = exports.MESSAGES = exports.EVENTS = exports.RESPONSE_TYPES = exports.WATCHLIST_PAGE_PATH = exports.SESSION_STORAGE = void 0;
exports.SESSION_STORAGE = {
    EXPIRY_TIME_OFFSET: 30,
    SESSION_KEY_NAME: 'favorites_ui_watch_Item_Data',
};
exports.WATCHLIST_PAGE_PATH = '/mye/myebay/watchlist';
exports.RESPONSE_TYPES = {
    ADD_TO_WATCH_LIST_SUCCESS: 'AddToWatchListSuccess',
    WATCH_LIST_FULL: 'WatchListIsFull',
    CSRF_TOKEN_ERROR: 'CSRF_TOKEN_VALIDATION_ERROR',
};
exports.EVENTS = {
    UPDATE_WATCH_STATUS: 'UPDATE_WATCH_STATUS',
    HANDLE_WATCH_ACTION: 'HANDLE_WATCH_ACTION',
    WATCH_UPDATE_HANDLER: 'watchUpdateHandler',
    WATCH_ACTION: 'watchAction',
    UNWATCH_ACTION: 'unwatchAction',
};
exports.MESSAGES = {
    ERROR: 'Something went wrong. Please try again.',
};
exports.LINKID = '180878';
exports.DEFAULT_TRACKING_DATA = {
    pageId: '',
    eventAction: '',
    eventFamily: '',
    actionKind: '',
    linkId: '',
};
